import { render, staticRenderFns } from "./ppnkeluarnsfp.vue?vue&type=template&id=aef03a84"
import script from "./ppnkeluarnsfp.vue?vue&type=script&lang=js"
export * from "./ppnkeluarnsfp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports